import React from 'react'
import AddressSearchBox from '../utils/AddressSearch'
import { authStatus, selectAuthUser } from '../auth/AuthSlice'
import { useAppDispatch, useAppSelector } from '../../app/hooks'
import { clearCacheForAddressAsync, selectClearCacheStatus } from '../analysis/AnalysisSlice'
import { useLocation, useNavigate, createSearchParams, useParams } from 'react-router-dom'
import { Box, Typography, Button } from '@mui/material'

const AdminClearCache = () => {
  const navigate = useNavigate()
  const { slugOrAddress } = useParams()
  const dispatch = useAppDispatch()
  const authUser = useAppSelector(selectAuthUser)
  const authProfileStatus = useAppSelector(authStatus)
  const clearCacheStatus = useAppSelector(selectClearCacheStatus)
  return (
    <Box>
      {slugOrAddress ? <>
        <Button variant='outlined' sx={{ display: 'flex' }} onClick={() => {
          navigate(`/admin/clearcache`)
        }}> Back</Button>
        <Typography variant="caption" gutterBottom>
          Clearing cache success <strong>{slugOrAddress}</strong>
        </Typography>
      </>
        : <>
          <Button variant='outlined' sx={{ display: 'flex', alignSelf: 'center' }} onClick={() => {
            navigate(`/admin`)
          }}> Back</Button>
          <Typography variant='body1'>Clear a cached address.</Typography>
          <AddressSearchBox showCredits={false} credits={authUser?.paidTierCount}
            onAddressSelect={(address: string, search: string, beds, baths, sqft) => {
              setTimeout(() => {
                dispatch(clearCacheForAddressAsync({
                  slugOrAddress: address, compCount: 25, propertyType: 'Single Family',
                  beds: beds ? beds : '', baths: baths ? baths : '', sqft: sqft ? sqft : ''
                }))
                navigate({
                  pathname: `/admin/clearcache/${address}`,
                  search
                })
              }, 500)
            }} />
        </>
      }
    </Box>
  )
}

export default AdminClearCache